// extracted by mini-css-extract-plugin
export var chevronIcon = "_bg-2";
export var teamName = "_bg-1";
export var teamSwitcherButton = "_bg-0";